import { apiService } from '../../shared/services/apiService';
import { SpringPagination } from '../../shared/interfaces/SpringPagination';
import { ParticipantListFilters } from '../interfaces/participants-list/ParticipantListFilters';
import {
  ParticipantDivision,
  ParticipantEditInfo,
  ParticipantRowInfo,
} from '../interfaces/participants-list/ParticipantRowInfo';

type GetParticipantsListResponse = SpringPagination<ParticipantRowInfo[]>;

type GetDivisionsResponse = {
  divisions: ParticipantDivision[] | null;
};

export const participantService = {
  async getParticipantsList(
    challengeId: number,
    params: ParticipantListFilters,
  ): Promise<GetParticipantsListResponse> {
    const resp = await apiService.post<GetParticipantsListResponse>(
      `/api/challenges/${challengeId}/participants/filtered`,
      params,
    );

    return resp.data;
  },

  async deleteParticipant(challengeId: number, participantId: number): Promise<void> {
    await apiService.delete(
      `/api/challenges/${challengeId}/participants/${participantId}`,
    );
  },

  async updateParticipant(
    challengeId: number,
    participantId: number,
    data: ParticipantEditInfo,
  ): Promise<ParticipantRowInfo> {
    const resp = await apiService.put<ParticipantRowInfo>(
      `/api/challenges/${challengeId}/participants/${participantId}`,
      data,
    );

    return resp.data;
  },

  async getDivisions(challengeId: number): Promise<GetDivisionsResponse> {
    const resp = await apiService.get<GetDivisionsResponse>(
      `/api/challenges/${challengeId}/divisions`,
    );

    return resp.data;
  },
};
